<template>
  <div id="app" style="height: 100%">
    <Head></Head>
    <router-view />
    <Foot></Foot>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'
export default {
  name: 'App',
  components: {
    Head,
    Foot
  }

}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  scrollbar-width: none;
  font-family: "Microsoft Yahei";
  cursor:pointer;
}

body {
    padding-top: 6.25rem;
    color: #5a5a5a;
	  overflow-x: hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue